'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var snakeCase = require('snake-case');
var isPlainObject = require('is-plain-object');
var isDotNotation = function isDotNotation(key) {
  return (/\./.test(key)
  );
};

var snakeobj = function snakeobj(data) {
  var exclude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (Array.isArray(data)) return data.map(function (item) {
    return snakeobj(item, exclude);
  });
  if (!isPlainObject(data)) return data;

  var transform = function transform() {
    return Object.keys(data).reduce(applySnakeCase, {});
  };

  var applySnakeCase = function applySnakeCase(result, key) {
    var newKey = buildNewKey(key);
    if (isPlainObject(data[key])) return snakeDeepObject(newKey, result, data[key]);
    if (Array.isArray(data[key])) return snakeArray(newKey, result, data[key]);
    return snakeProperty(newKey, result, data[key]);
  };

  var buildNewKey = function buildNewKey(key) {
    if (isDotNotation(key)) return snakeDotNotation(key);
    return shouldTransform(key) ? snakeCase(key) : key;
  };

  var snakeDotNotation = function snakeDotNotation(key) {
    return key.split('.').map(snakeCase).join('.');
  };

  var shouldTransform = function shouldTransform(key) {
    return !isException(key);
  };

  var isException = function isException(key) {
    return exclude.indexOf(key) > -1;
  };

  var snakeDeepObject = function snakeDeepObject(newKey, result, data) {
    var func = function func() {
      return snakeobj(data, exclude);
    };
    return applyOnResult(newKey, result, func);
  };

  var snakeArray = function snakeArray(newKey, result, dataArr) {
    var func = function func() {
      return dataArr.map(function (item) {
        return snakeobj(item, exclude);
      });
    };
    return applyOnResult(newKey, result, func);
  };

  var snakeProperty = function snakeProperty(newKey, result, data) {
    var func = function func() {
      return data;
    };
    return applyOnResult(newKey, result, func);
  };

  var applyOnResult = function applyOnResult(newKey, result, func) {
    var partial = {};
    partial[newKey] = func();
    return _extends({}, result, partial);
  };

  return transform();
};

module.exports = snakeobj;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snakeobj/dist/index.js
// module id = 230
// module chunks = 1 2